import * as _ from 'lodash';
import { CSSProperties } from 'react';

export function fade(color, alpha) {
  const colorDec = parseInt(color.substr(1), 16);
  const B = colorDec % 0x100;
  const G = (colorDec >> 8) % 0x100;
  const R = (colorDec >> 16) % 0x100;

  return `rgba(${R}, ${G}, ${B}, ${alpha})`;
}

export function getBackgroundById(id) {
  const uniqueInt = id ? Number(id.replace(/[^0-9]/g, '').substr(-10)) : 0;
  const backgroundColor = ['#586F8B', '#586F8B', '#586F8B', '#586F8B'][uniqueInt % 4];

  const backgroundImageName = ['angular', 'bokeh', 'hexadance', 'hills', 'lightshow'][
    uniqueInt % 5
  ];

  const type = ['dark', 'dark'][uniqueInt % 2];

  const backgroundImageUrl = `/img/card-background/${type}/${backgroundImageName}.svg`;

  const backgroundImage = `url("${backgroundImageUrl}")`;

  return {
    type,
    styles: {
      backgroundColor,
      backgroundImage,
    },
  };
}

export function mix(...styles: (CSSProperties | CSSProperties[])[]): CSSProperties {
  const flattenedStyles = _.flatten(styles);

  return flattenedStyles.reduce((final, style) => _.assign(final, style), {});
}
